import React, { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import Navbar from './Navbar';

const Layout = ({ children }) => {
  const { theme } = useContext(ThemeContext);

  return (
    <div className={`min-h-screen flex flex-col ${theme === 'dark' ? 'bg-[#0B0F19] text-white' : 'bg-gray-50 text-gray-900'}`}>
      <Navbar />
      <main className="flex-1 flex overflow-hidden">{children}</main>
    </div>
  );
};

export default Layout;